/**
 * 组织分类查看
 * @description 组织分类查看
 * @author mll
 * @date 2020-4-28
 */
import React from 'react';
import { component_tool } from '@/tool'
const { WizComponent, WizRow, WizCol, WizTypography } = component_tool;
const { Title, Text, Paragraph } = WizTypography
export default class LookOrgNodeCategory extends WizComponent {


    constructor(props) {
        super(props);
        this.state = {
        }
    }

    _row = (key, value) => {
        return (
            <WizRow>
                <WizCol span={6}><Paragraph style={{ textAlign: 'right' }}>{key}:</Paragraph></WizCol>
                <WizCol span={14} offset={1}><Paragraph>{value}</Paragraph></WizCol>
            </WizRow>
        )
    }
    _rows = (obj) => {
        let r = []
        Object.keys(obj).forEach(l => {
            r.push(this._row(l, obj[l]))
        });
        return r
    }

    render() {
        let { parentName, name, code, state, createBy, createTime, updateBy, updateTime } = this.props['record'];
        return (
            <>
                {this._rows({
                    '上级组织类型': parentName,
                    '组织类型名称': name,
                    '组织类型编号': code,
                    '状态': state === 1 ? '有效' : '无效',
                    '创建人': createBy,
                    '创建时间': createTime,
                    '修改人': updateBy,
                    '修改时间': updateTime
                })}
            </>
        )
    }

}